var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAopFr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 188.64 188.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffde13;\n      }\n\n      .cls-2 {\n        font-family: TimesNewRomanPSMT, 'Times New Roman';\n        font-size: 16.44px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #e4072f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGOS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "100.97 10.12 109.08 1.17 114.06 12.2 123.47 4.63 126.67 16.3 137.15 10.3 138.48 22.33 149.77 18.04 149.2 30.13 161.02 27.66 158.57 39.51 170.63 38.92 166.36 50.25 178.36 51.55 172.37 62.07 184.03 65.23 176.47 74.68 187.48 79.64 178.54 87.79 188.64 94.41 178.53 101.05 187.48 109.17 176.46 114.16 184.03 123.58 172.36 126.77 178.36 137.26 166.34 138.59 170.63 149.89 158.55 149.32 161.02 161.15 149.17 158.7 149.76 170.78 138.45 166.5 137.15 178.52 126.64 172.52 123.47 184.18 114.03 176.62 109.08 187.64 100.93 178.69 94.32 188.8 87.68 178.68 79.57 187.64 74.59 176.61 65.18 184.18 61.98 172.51 51.5 178.52 50.17 166.48 38.88 170.77 39.45 158.68 27.63 161.15 30.08 149.3 18.02 149.89 22.29 138.56 10.28 137.26 16.27 126.74 4.62 123.57 12.18 114.12 1.16 109.17 10.11 101.02 0 94.4 10.11 87.75 1.16 79.64 12.19 74.65 4.62 65.23 16.28 62.03 10.28 51.54 22.3 50.21 18.02 38.91 30.1 39.48 27.63 27.65 39.47 30.1 38.88 18.03 50.2 22.31 51.5 10.29 62.01 16.28 65.18 4.62 74.62 12.19 79.57 1.16 87.71 10.11 94.33 0 100.97 10.12"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.83,94.4C11.83,48.8,48.76,11.84,94.32,11.84s82.49,36.97,82.49,82.56-36.93,82.56-82.49,82.56S11.83,140,11.83,94.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.83,94.4C11.83,48.8,48.76,11.84,94.32,11.84s82.49,36.97,82.49,82.56-36.93,82.56-82.49,82.56S11.83,140,11.83,94.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.13,94.36c0-31.04,25.14-56.2,56.16-56.2s56.15,25.16,56.15,56.2-25.14,56.2-56.15,56.2-56.16-25.16-56.16-56.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.13,94.36c0-31.04,25.14-56.2,56.16-56.2s56.15,25.16,56.15,56.2-25.14,56.2-56.15,56.2-56.16-25.16-56.16-56.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "136.43 68.2 134.71 63.22 133.04 68.2 127.67 68.21 132.03 71.29 130.35 76.27 134.71 73.19 139.06 76.27 137.46 71.31 141.75 68.21 136.43 68.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "119.15 51.85 117.42 46.87 115.76 51.85 110.38 51.86 114.74 54.94 113.07 59.92 117.43 56.83 121.77 59.92 120.17 54.96 124.46 51.86 119.15 51.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.73 45.39 94.01 40.41 92.34 45.4 86.96 45.4 91.32 48.48 89.65 53.46 94.02 50.38 98.36 53.46 96.76 48.5 101.05 45.4 95.73 45.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "72.6 51.85 70.87 46.87 69.21 51.86 63.83 51.86 68.19 54.94 66.52 59.92 70.88 56.84 75.22 59.92 73.62 54.96 77.91 51.86 72.6 51.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "55.31 68.2 53.58 63.22 51.92 68.2 46.54 68.21 50.9 71.29 49.23 76.27 53.59 73.19 57.93 76.27 56.34 71.31 60.63 68.21 55.31 68.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.9 92.92 47.18 87.94 45.51 92.92 40.13 92.93 44.49 96.01 42.82 100.99 47.18 97.91 51.53 100.99 49.93 96.03 54.22 92.93 48.9 92.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "56.26 115.46 54.53 110.48 52.87 115.47 47.49 115.47 51.85 118.56 50.18 123.54 54.54 120.45 58.88 123.54 57.29 118.57 61.58 115.47 56.26 115.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "71.65 131.81 69.92 126.83 68.26 131.82 62.88 131.82 67.24 134.9 65.57 139.88 69.93 136.79 74.27 139.88 72.67 134.92 76.96 131.82 71.65 131.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.73 140.24 94.01 135.26 92.34 140.24 86.96 140.24 91.32 143.33 89.65 148.31 94.01 145.22 98.36 148.31 96.76 143.34 101.05 140.24 95.73 140.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "119.82 131.81 118.09 126.83 116.43 131.82 111.05 131.82 115.41 134.91 113.74 139.89 118.1 136.8 122.45 139.89 120.85 134.92 125.14 131.82 119.82 131.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.21 115.46 133.48 110.49 131.82 115.47 126.44 115.47 130.8 118.56 129.12 123.54 133.49 120.45 137.83 123.54 136.24 118.57 140.52 115.47 135.21 115.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "143.12 92.82 141.39 87.84 139.73 92.82 134.35 92.82 138.71 95.91 137.04 100.89 141.4 97.8 145.74 100.89 144.15 95.92 148.43 92.82 143.12 92.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.63,124.12c-9.76-10.25-30.03-19.32-54.07-22.95l-.11-.61c-.26-1.46-.42-2.91-.5-4.35,24.9,3.58,47.48,13.01,58.56,24.99-1.22,1.06-2.51,2.04-3.88,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.75,129.56c-4.52-7.7-18.28-15.24-35.84-18.79-.88-1.69-1.63-3.46-2.23-5.32,20.15,3.47,37.9,12.28,43.02,23.13-1.05,.29-2.12,.53-3.22,.72-.57,.1-1.15,.19-1.72,.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.71,115.3c9.46,2.54,17.5,7.03,20.15,13.52-8.09-2-15.25-6.81-20.15-13.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.96,95.72c12.16-3.35,24.44-4.62,34.7-3.68,.08,1.24,.1,2.47,.06,3.68-8.27-.81-18.25-.13-28.71,2.24,1.79,.7,3.54,1.43,5.24,2.19,8.56-1.32,16.71-1.14,22.91,.68-.22,1.21-.51,2.4-.85,3.57-4.19-1.26-9.66-1.73-15.81-1.29,4.82,2.44,9.23,5.08,13.13,7.88-.75,1.42-1.6,2.78-2.53,4.09-14.66-10.63-37.81-19.36-64.11-23.01,.11-1.6,.32-3.18,.64-4.73,8.26,1.16,16.32,2.81,23.97,4.89,15.13-5.26,30.85-7.96,44.65-8.03,.35,1.18,.65,2.38,.88,3.61-11.87-.05-25.56,1.94-39.38,6.21,1.77,.55,3.51,1.12,5.23,1.72Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "136.43 68.2 134.71 63.22 133.04 68.2 127.67 68.21 132.03 71.29 130.35 76.27 134.71 73.19 139.06 76.27 137.46 71.31 141.75 68.21 136.43 68.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "119.15 51.85 117.42 46.87 115.76 51.85 110.38 51.86 114.74 54.94 113.07 59.92 117.43 56.83 121.77 59.92 120.17 54.96 124.46 51.86 119.15 51.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.73 45.39 94.01 40.41 92.34 45.4 86.96 45.4 91.32 48.48 89.65 53.46 94.02 50.38 98.36 53.46 96.76 48.5 101.05 45.4 95.73 45.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "72.6 51.85 70.87 46.87 69.21 51.86 63.83 51.86 68.19 54.94 66.52 59.92 70.88 56.84 75.22 59.92 73.62 54.96 77.91 51.86 72.6 51.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "55.31 68.2 53.58 63.22 51.92 68.2 46.54 68.21 50.9 71.29 49.23 76.27 53.59 73.19 57.93 76.27 56.34 71.31 60.63 68.21 55.31 68.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.9 92.92 47.18 87.94 45.51 92.92 40.13 92.93 44.49 96.01 42.82 100.99 47.18 97.91 51.53 100.99 49.93 96.03 54.22 92.93 48.9 92.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "56.26 115.46 54.53 110.48 52.87 115.47 47.49 115.47 51.85 118.56 50.18 123.54 54.54 120.45 58.88 123.54 57.29 118.57 61.58 115.47 56.26 115.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "71.65 131.81 69.92 126.83 68.26 131.82 62.88 131.82 67.24 134.9 65.57 139.88 69.93 136.79 74.27 139.88 72.67 134.92 76.96 131.82 71.65 131.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.73 140.24 94.01 135.26 92.34 140.24 86.96 140.24 91.32 143.33 89.65 148.31 94.01 145.22 98.36 148.31 96.76 143.34 101.05 140.24 95.73 140.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "119.82 131.81 118.09 126.83 116.43 131.82 111.05 131.82 115.41 134.91 113.74 139.89 118.1 136.8 122.45 139.89 120.85 134.92 125.14 131.82 119.82 131.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.21 115.46 133.48 110.49 131.82 115.47 126.44 115.47 130.8 118.56 129.12 123.54 133.49 120.45 137.83 123.54 136.24 118.57 140.52 115.47 135.21 115.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "143.12 92.82 141.39 87.84 139.73 92.82 134.35 92.82 138.71 95.91 137.04 100.89 141.4 97.8 145.74 100.89 144.15 95.92 148.43 92.82 143.12 92.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.63,124.12c-9.76-10.25-30.03-19.32-54.07-22.95l-.11-.61c-.26-1.46-.42-2.91-.5-4.35,24.9,3.58,47.48,13.01,58.56,24.99-1.22,1.06-2.51,2.04-3.88,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.75,129.56c-4.52-7.7-18.28-15.24-35.84-18.79-.88-1.69-1.63-3.46-2.23-5.32,20.15,3.47,37.9,12.28,43.02,23.13-1.05,.29-2.12,.53-3.22,.72-.57,.1-1.15,.19-1.72,.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.71,115.3c9.46,2.54,17.5,7.03,20.15,13.52-8.09-2-15.25-6.81-20.15-13.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.96,95.72c12.16-3.35,24.44-4.62,34.7-3.68,.08,1.24,.1,2.47,.06,3.68-8.27-.81-18.25-.13-28.71,2.24,1.79,.7,3.54,1.43,5.24,2.19,8.56-1.32,16.71-1.14,22.91,.68-.22,1.21-.51,2.4-.85,3.57-4.19-1.26-9.66-1.73-15.81-1.29,4.82,2.44,9.23,5.08,13.13,7.88-.75,1.42-1.6,2.78-2.53,4.09-14.66-10.63-37.81-19.36-64.11-23.01,.11-1.6,.32-3.18,.64-4.73,8.26,1.16,16.32,2.81,23.97,4.89,15.13-5.26,30.85-7.96,44.65-8.03,.35,1.18,.65,2.38,.88,3.61-11.87-.05-25.56,1.94-39.38,6.21,1.77,.55,3.51,1.12,5.23,1.72Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(52.75 142.59) rotate(-137.56)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(49.7 139.84) rotate(-133.25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2022")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(45.78 135.63) rotate(-128.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(43.54 133.28) rotate(-122.56)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(37.23 123.19) rotate(-112.98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(33.67 114.77) rotate(-104.57)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(31.33 105.91) rotate(-95.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(30.33 95.9) rotate(-87.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(30.83 85.84) rotate(-78.34)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(32.79 75.95) rotate(-68.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(36.44 66.57) rotate(-59.95)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(41.6 57.94) rotate(-52.79)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(44.75 53.42) rotate(-44.89)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(53.18 45.04) rotate(-34.25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(63.14 38.55) rotate(-27.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(66.71 36.45) rotate(-20.03)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(77.95 32.62) rotate(-13.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&apos;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(80.78 31.68) rotate(-6.78)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(92.59 30.32) rotate(3.49)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(103.54 31.17) rotate(10.83)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(108.98 31.99) rotate(18.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(120.16 35.96) rotate(26.12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(125.19 38.19) rotate(33.78)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(135.05 44.88) rotate(43.58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(142.2 51.91) rotate(50)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(144.96 54.99) rotate(56.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(150.13 62.55) rotate(65.38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(154.75 72.55) rotate(75.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(157.56 84.09) rotate(85.56)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(158.34 94.14) rotate(94.07)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xC9")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(157.71 104.18) rotate(103.83)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(154.79 115.71) rotate(113.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xC9")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(150.7 124.93) rotate(123.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(145.07 133.22) rotate(129.62)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(142.47 136.41) rotate(134.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2022")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAopFr);
export default __webpack_public_path__ + "static/media/logo_aop_fr.cde98788e42b6ed297302d824ed9a23f.svg";
export { ForwardRef as ReactComponent };